
import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { AssigmentAcceptedGridDataService } from 'common/services/data-services/admin/assignment/assignment-accpeted-grid-data.service';
import { AssignementAcceptedGridMetaModel } from 'common/models/page-models/Assignment Accepted Model/assignment-accepted-grid-meta.model';
import { AssignemntAcceptedListingModel } from 'common/models/page-models/Assignment Accepted Model/assignment-accepted-params.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { environment } from 'src/environments/environment';
// import { assignmentAcceptedDataService } from 'common/services/data-services/custom-service/assignment-accepted-service';
import { SmMetaModel } from 'common/models/utility-models/meta-model';

@Injectable({
    providedIn: 'root'
})
export class AssigmentAcceptedGridWidgetService extends GridWidgetService<AssignmentModel, AssignemntAcceptedListingModel> {
    constructor(protected override ds: AssigmentAcceptedGridDataService, protected ss: SystemService) {
        super(ds);
    }

    createQueryParams(queryParam): GridParams {
        for (const key in queryParam) {
            this.queryparm[key] = queryParam[key];
        }
        return this.queryparm;
    }


    getMetaModel(): MetaModel {
        const meta = new AssignementAcceptedGridMetaModel().getMetaModel();
        return meta;
    }

    initToggle(url, payload) {
        this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + url, true).then((data) => {
            this.ss.showSuccess(data['header'].msg)
        })
    }

    override prepareMetaModel(
        dataModel: AssignemntAcceptedListingModel,
        metaModel: AssignementAcceptedGridMetaModel,
        routeData: WidgetModel,
        event: any = null
    ): Promise<SmMetaModel> {
        return new Promise<AssignementAcceptedGridMetaModel>((resolve, reject) => {
            const postData = {
                pageNumber: 1,
                pageSize: 10,
                search_keyword: 0,
            };

            // this.assignmentAccepted.postData(postData).then((data) => {
            //     metaModel.properties.details.assignmentAccepted = data;
            // });
             
            // metaModel.pageTitle = 
            // console.log(routeData,'=====================');
            
            metaModel.pageTitle = routeData.transferData.navPageType === "Invited" ? 'Invited' : 'Assignment Accepted'
            resolve(metaModel);
        });

    }
}

